<template>
    <div class="select-major-container">
      <div class="title-section">
        <span class="title-line"></span>
        <h3 class="title">选择就读地点</h3>
        <span class="title-line"></span>
      </div>
      <div class="content-box">
        <div class="form-row">
          <label class="form-label">选择就读地点:</label>
          <el-select 
            v-model="activeId" 
            placeholder="请选择" 
            class="major-select"
            @change="handleMajorChange"
            size="small"
            filterable
          >
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="`${item.code}-${item.name}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        
        <div class="info-section" v-if="info">
          <div class="info-row">
            <div class="info-item">
              <label class="info-label">助学点:</label>
              <span class="info-value">{{ info.code+'-'+info.name }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">联系人:</label>
              <span class="info-value">{{ info.principal }}</span>
            </div>
            
          </div>
          <div class="info-row">
            <div class="info-item">
              <label class="info-label">联系电话:</label>
              <span class="info-value">{{ info.phone }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">地&nbsp;&nbsp;&nbsp;&nbsp;址:</label>
              <span class="info-value">{{ info.address }}</span>
            </div>
          </div>
          <!-- <div class="info-row">
            <div class="info-item full-width">
              <label class="info-label">学习形式:</label>
              <span class="info-value">{{ info.studyMode }}</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="action-buttons">
        <button v-if="showPrev" class="prev-btn" @click="handlePrev">上一步</button>
        <button class="next-btn" :disabled="!activeId" @click="handleNext">下一步</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'helpInfo',
    props: {
      groupType: {
        type: [String, Number],
        default: null
      },
      helpId: {
        type: [String, Number],
        default: null
      },
      showPrev: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
        activeId: '',
        list: [],
        info: null
      }
    },
    watch: {
      groupType: {
        handler() {
          this.loadMajorList()
        },
        immediate: true
      },
      helpId: {
        handler(newVal) {
          console.log('helpId------'+newVal)
          if (newVal && this.list.length > 0) {
            this.activeId = newVal
            this.loadHelpInfo(newVal)
          }else{
            this.info = ''
            this.activeId = ''
          }
        },
        immediate: true
      },
      list: {
        handler(newVal) {
          // 当列表加载完成后，如果有 helpId，自动选中
          if (newVal && newVal.length > 0 && this.helpId) {
            this.activeId = this.helpId
            this.loadHelpInfo(this.helpId)
          }
        }
      }
    },
    methods: {
      handlePrev() {
        this.$emit('prev-step')
      },
      handleNext() {
        if (this.activeId) {
          localStorage.setItem('helpInfo', JSON.stringify({
            id: this.activeId,
            name: this.info.name,
            code: this.info.code,
            address: this.info.address,
            principal: this.info.principal,
            phone: this.info.phone,
            studyMode: this.info.studyMode,
            school: this.info.school
          }))
          this.$emit('next-step', this.activeId)
        }
      },
      handleMajorChange(value) {
        this.activeId = value
        this.loadHelpInfo(value)
      },
      loadMajorList() {
        const params = {}
        if (this.groupType !== null && this.groupType !== undefined && this.groupType !== '') {
          params.type = this.groupType
        }
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getRegGroup', params).then(res => {
          this.list = res
          // 列表加载完成后，如果有 helpId，自动选中并加载详情
          if (this.helpId && res && res.length > 0) {
            this.$nextTick(() => {
              this.activeId = this.helpId
              this.loadHelpInfo(this.helpId)
            })
          }
        })
      },
      loadHelpInfo(helpId) {
        if (!helpId){
          this.info = ''
          return
        }
        this.$http.get(this.MOCK_PREFIX + '/student/pc/getRegGroupInfo', {
          id: helpId
        }).then(res => {
          this.info = res || ''
          this.$emit('changeHelpInfo', helpId)
        }).catch(err => {
          console.error('加载就读地点信息失败:', err)
        })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .select-major-container {
    width: 100%;
    padding: 20px;
  }
  
  .title-section {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    gap: 15px;
  }
  
  .title-line {
    flex: 1;
    height: 1px;
    background: repeating-linear-gradient(
      to right,
      #ddd 0px,
      #ddd 4px,
      transparent 4px,
      transparent 8px
    );
    max-width: 200px;
  }
  
  .title {
    font-size: 20px;
    font-weight: 600;
    color: #1A1A1A;
    margin: 0;
    white-space: nowrap;
  }
  
  .content-box {
    border-radius: 10px;
    padding: 40px 40px 20px 40px;
    background: #F9F9F9;
    border: 1px solid #F3F3F3;
  }
  
  .form-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .form-label {
      min-width: 100px;
      font-size: 14px;
      color: #767676;
      margin-bottom: 0;
    }
    
    .major-select {
      flex: 1;
      max-width: 400px;
    }
  }
  
  .info-section {
    margin-bottom: 30px;
  }
  
  .info-row {
    display: flex;
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .info-item {
    flex: 1;
    display: flex;
    align-items: center;
    
    &.full-width {
      flex: 1 1 100%;
    }
    
    .info-label {
      min-width: 100px;
      font-size: 14px;
      color: #767676;
      font-weight: 500;
      margin-bottom: 0;
    }
    
    .info-value {
      flex: 1;
      font-size: 14px;
      color: #1A1A1A;
    }
  }
  
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 50px;
    margin-top: 30px;
  }
  
  .prev-btn,
  .next-btn {
    width: 160px;
    height: 40px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
    border: none;
  }
  
  .prev-btn {
    background: #fff;
    color: #4084FF;
    border: 1px solid #4084FF;
  
    &:hover {
      background: #f5f5f5;
    }
  }
  
  .next-btn {
    background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
    color: #fff;
  
    &:hover:not(:disabled) {
      opacity: 0.9;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
  
  // Element UI 样式覆盖
  ::v-deep .major-select {
    width: 100%;
    
    .el-input__inner {
      border-radius: 6px;
      border: 1px solid #DCDFE6;
      
      &:focus {
        border-color: #1687DE;
      }
    }
    
    .el-input__suffix {
      .el-input__suffix-inner {
        .el-select__caret {
          color: #909399;
        }
      }
    }
  }
  </style>